import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Import translation files
import enTranslations from './locales/en/translation.json';
import esTranslations from './locales/es/translation.json';
import frTranslations from './locales/fr/translation.json';
import deTranslations from './locales/de/translation.json';
import ptTranslations from './locales/pt/translation.json';
import itTranslations from './locales/it/translation.json';
import ruTranslations from './locales/ru/translation.json';
import jaTranslations from './locales/ja/translation.json';
import zhTranslations from './locales/zh/translation.json';
import arTranslations from './locales/ar/translation.json';

const resources = {
  en: {
    translation: enTranslations,
  },
  es: {
    translation: esTranslations,
  },
  fr: {
    translation: frTranslations,
  },
  de: {
    translation: deTranslations,
  },
  pt: {
    translation: ptTranslations,
  },
  it: {
    translation: itTranslations,
  },
  ru: {
    translation: ruTranslations,
  },
  ja: {
    translation: jaTranslations,
  },
  zh: {
    translation: zhTranslations,
  },
  ar: {
    translation: arTranslations,
  },
};

// Function to detect language from URL path
function getLanguageFromUrl(): string {
  if (typeof window !== 'undefined') {
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    const language = pathSegments[0];
    const supportedLanguages = ['en', 'es', 'fr', 'de', 'pt', 'it', 'ru', 'ja', 'zh', 'ar'];
    
    if (supportedLanguages.includes(language)) {
      return language;
    }
  }
  return 'en'; // Default fallback
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: getLanguageFromUrl(), // Set initial language from URL
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export default i18n;
